import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  background: rgba(14, 14, 16, 0.8);
  backdrop-filter: blur(10px);
  padding: 1rem 2rem;
  z-index: 1000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const Logo = styled.h2`
  background: linear-gradient(45deg, #39c0ed, #7a43e5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  font-size: 1.5rem;
`;

const NavLinks = styled.div<{ isOpen: boolean }>`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(14, 14, 16, 0.95);
    flex-direction: column;
    padding: 2rem;
    transform: ${props => props.isOpen ? 'translateY(0)' : 'translateY(-100vh)'};
    transition: transform 0.3s ease;
  }
`;

const NavLink = styled.a`
  color: #fff;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: #39c0ed;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

const DownloadButton = styled(motion.a)`
  background: linear-gradient(45deg, #39c0ed, #7a43e5);
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(57, 192, 237, 0.4);
  }
`;

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <HeaderContainer>
      <Nav>
        <Logo>Contact Manager</Logo>
        <NavLinks isOpen={isMenuOpen}>
          <NavLink href="#features">Features</NavLink>
          <NavLink href="#about">About</NavLink>
          <NavLink href="https://github.com/Mrtracker-new/Contact-manager/wiki" target="_blank">Documentation</NavLink>
          <DownloadButton
            href="https://github.com/Mrtracker-new/Contact-manager/releases/download/v2.0/Contact-Manager.apk"
            target="_blank"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Download
          </DownloadButton>
        </NavLinks>
        <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </MenuButton>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;
